<div fxLayout="column" fxLayoutGap="10px">
	<rpshared-railroad-sub-code
		[formControl]="control"
		rpsharedRemoveHost
	></rpshared-railroad-sub-code>
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button
			mat-button
			[disabled]="group.invalid"
			color="primary"
			[mat-dialog-close]="group"
		>
			Save
		</button>
	</div>
</div>
